import React, { Fragment } from "react";
import { Element } from "react-scroll";
import Navbar from "../../components/Navbar/Navbar";
import Hero from "../../components/hero/hero";
import FunfactSecion from "../../components/FunfactSection/FunfactSection";
import About from "../../components/about/about";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import ClientSection from "../../components/ClientSection/ClientSection";
import PortofolioSection from "../../components/PortofolioSection/PortofolioSection";
import ProductSection from "../../components/ProductSection/ProductSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import Phone from "../../images/telephone.svg";
import Logo from "../../images/logo/logo.webp";
import contacts from "../../api/contacts";
const HomePage = () => {
  return (
    <Fragment>
      <Navbar
        Logo={Logo}
        telephone={Phone}
        hclass={"wpo-site-header s1"}
        contact={contacts}
      />
      <Element name="home">
        <Hero contact={contacts} />
      </Element>
      <FunfactSecion hclass="funfact-section" />
      <Element name="about">
        <About />
      </Element>
      <Element name="services">
        <ServiceSection hclass={"services-section"} />
      </Element>
      <Element name="client">
        <ClientSection />
      </Element>
      <Element name="portofolio">
        <PortofolioSection hclass={"project-section"} />
      </Element>
      <Element name="product">
        <ProductSection contact={contacts} />
      </Element>
      <Footer contact={contacts} />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default HomePage;
